export function getImageAlt(item, fallback = "ICFC Finance") {
  if (!item) return fallback;
  return item.file_alt || item.image_alt || fallback;
}
